export const CHANGE_QUOTATION_EQUIPMENT_QUANTITY =
  '/proposal/quotation/item/qty'

export const GET_EQUIPMENTS_CATEGORIES = '/loja/categorias?ordem=asc'
export const GET_EQUIPMENTS_BRANDS = '/loja/marcas?onlyVisible=1'
export const REDEFINE_QUOTATION_KIT = '/proposal/quotation/redefine'
export const ADD_EQUIPMENT_TO_QUOTATION = '/proposal/quotation/add/item'
